import React, { useCallback, useEffect, useState } from "react";

import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TablePagination,
  Grid,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import WallpaperIcon from "@mui/icons-material/Wallpaper";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import { api_base, Api_Token } from "../../../env";
import { useAlertContext } from "../../../service/AlertServices";
import { ConfirmDeletePopup } from "../../../composant/Popup/confirmDelete";
import Indexdasbord from "../../../composant/navbar/indexDashbord";
import { BackLoadingSimple } from "../../../composant/loading/backLoading";
import { useSelector } from "react-redux";
import PopupGestionBackground from "../../../composant/Popup/PopupGestionBackground";

export default function PageEvents() {
  return <Indexdasbord Children={<EventsManagement />} />;
}

function EventsManagement() {
  const [events, setEvents] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [loading, setLoading] = useState(true);
  const { showAlert } = useAlertContext();
  const [popupDelete, setPopupDelete] = useState(false);
  const [idDelete, setIdDelete] = useState();
  const [Data, setData] = useState();
  const [popupForm, setPopupForm] = useState(false);
  const { Produits } = useSelector((state) => state.dataApp);
  const [formData, setFormData] = useState({
    id: null,
    Nom: "",
    code: "",
    startDate: "",
    endDate: "",
    logo: "",
    BG_ImageCodeColor: "",
    logoImage: null,
    backgroundImageUrl: null,
    backgroundImagePageUrl: null,
    backgroundPageHomeUrl: null,
    backgroundPageUrl: null,
    textImage: "",
    Rm_Bg: false,
    ImageGratuit: 0,
    idProduit: "",
  });
  const [openBackground, setOpenBackground] = useState(false);
  const [openBackgroundId, setOpenBackgroundId] = useState(null);

  const fetchEvents = useCallback(async () => {
    setLoading(true);
    try {
      let url = `${api_base}event/getEvents?page=${
        page + 1
      }&limit=${rowsPerPage}`;
      if (filterText?.trim()) {
        url += `&filterText=${encodeURIComponent(filterText.trim())}`;
      }
      const response = await axios.get(url);
      setEvents(response.data.data);
      setData(response.data);
    } catch (error) {
      showAlert("Erreur lors de la récupération des events", "error");
    } finally {
      setLoading(false);
    }
  }, [page, rowsPerPage, filterText, showAlert]);

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      fetchEvents();
    }, 500);

    return () => clearTimeout(debounceTimer);
  }, [filterText, fetchEvents]);

  useEffect(() => {
    fetchEvents();
  }, [page, rowsPerPage, fetchEvents]);
  /*
  useEffect(() => {
    if (
      formData.logoImage &&
      typeof formData.logoImage === "string" &&
      formData.logoImage.startsWith("http")
    ) {
      setLogoPreview(formData.logoImage);
    } else if (!formData.logoImage) {
      setLogoPreview("");
    }
    if (
      formData.backgroundImageUrl &&
      typeof formData.backgroundImageUrl === "string" &&
      formData.backgroundImageUrl.startsWith("http")
    ) {
      setBackgroundPreview(formData.backgroundImageUrl);
    } else if (!formData.backgroundImageUrl) {
      setBackgroundPreview("");
    }

    if (
      formData.backgroundPageUrl &&
      typeof formData.backgroundPageUrl === "string" &&
      formData.backgroundPageUrl.startsWith("http")
    ) {
      setBackgroundPagePreview(formData.backgroundPageUrl);
    } else if (!formData.backgroundPageUrl) {
      setBackgroundPagePreview("");
    }
  }, [
    formData.logoImage,
    formData.backgroundImageUrl,
    formData.backgroundPageUrl,
  ]);*/
  const handleDelete = async () => {
    try {
      //await axios.delete(`${api_base}event/deleteEvent/${idDelete}`);
      await Api_Token.delete(`event/deleteEvent/${idDelete}`);
      showAlert("Suppression réussie", "success");
      fetchEvents();
    } catch (error) {
      showAlert("Erreur suppression", "error");
    }
    setPopupDelete(false);
  };

  const handleColorChange = (e) => {
    setFormData({ ...formData, BG_ImageCodeColor: e.target.value });
  };

  const handleRmBgChange = (e) => {
    setFormData({ ...formData, Rm_Bg: e.target.value === "true" });
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      const form = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        form.append(key, value);
      });
      if (formData.id) {
        await Api_Token.put(`event/updateEvent/${formData.id}`, form, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        showAlert("Event modifié", "success");
      } else {
        await Api_Token.post(`event/createEvent`, form, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        showAlert("Event ajouté", "success");
      }

      // Reset state
      setPopupForm(false);
      DataInisial();
      //  setLogoPreview("");
      //  setBackgroundPreview("");
      fetchEvents();
    } catch (error) {
      console.error("Erreur formulaire :", error);
      showAlert("Erreur formulaire", "error");
    }
  };

  function DataInisial() {
    setFormData({
      id: null,

      Nom: "",
      code: "",
      startDate: "",
      endDate: "",
      logo: "",
      BG_ImageCodeColor: "",
      logoImage: "",
      backgroundPageHomeUrl: "",
      backgroundImagePageUrl: "",
      backgroundPageUrl: "",
      backgroundImageUrl: "",
      textImage: "",
      Rm_Bg: false,
      ImageGratuit: 0,
      idProduit: "",
    });
  }

  return (
    <Box p={4}>
      <Typography variant="h5" mb={3}>
        Liste des Events
      </Typography>
      <Paper>
        <Box display="flex" gap={2} mb={2} padding={2}>
          <TextField
            label="Filtrer par nom ou code"
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
          />
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => setPopupForm(true)}
          >
            Ajouter
          </Button>
        </Box>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center">
                <strong>Nom</strong>
              </TableCell>
              <TableCell align="center">
                <strong>Produit</strong>
              </TableCell>
              <TableCell align="center">
                <strong>Code</strong>
              </TableCell>
              <TableCell align="center">
                <strong>arrière plan couleur</strong>
              </TableCell>
              <TableCell align="center">
                <strong>Logo</strong>
              </TableCell>
              <TableCell align="center">
                <strong>background papier</strong>
              </TableCell>
              <TableCell align="center">
                <strong>background papier in home</strong>
              </TableCell>
              <TableCell align="center">
                <strong>background page Home</strong>
              </TableCell>
              <TableCell align="center">
                <strong>background page</strong>
              </TableCell>
              <TableCell align="center">
                <strong>text Image</strong>
              </TableCell>
              <TableCell align="center">
                <strong>supprime arrière plan </strong>
              </TableCell>

              <TableCell align="center">
                <strong>Date début</strong>
              </TableCell>
              <TableCell align="center">
                <strong>Date fin</strong>
              </TableCell>
              <TableCell align="center">
                <strong>Action</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {events.map((event) => (
              <TableRow key={event.id}>
                <TableCell align="center">{event.Nom}</TableCell>
                <TableCell align="center">
                  {event?.Produit?.NomProduit}
                </TableCell>
                <TableCell align="center">{event.code}</TableCell>
                <TableCell align="center">
                  {event.BG_ImageCodeColor ? (
                    <Box
                      sx={{
                        width: 32,
                        height: 32,
                        borderRadius: "4px",
                        background: event.BG_ImageCodeColor,
                        border: "1px solid #ccc",
                        display: "inline-block",
                      }}
                    />
                  ) : (
                    ""
                  )}
                </TableCell>
                <TableCell align="center">
                  {event.logoImage ? (
                    <img
                      src={event.logoImage}
                      alt="logo"
                      style={{ width: 40, height: 40, objectFit: "contain" }}
                    />
                  ) : (
                    ""
                  )}
                </TableCell>
                <TableCell align="center">
                  {event.backgroundImageUrl ? (
                    <img
                      src={event.backgroundImageUrl}
                      alt="background"
                      style={{ width: 40, height: 40, objectFit: "contain" }}
                    />
                  ) : (
                    ""
                  )}
                </TableCell>
                <TableCell align="center">
                  {event.backgroundImagePageUrl ? (
                    <img
                      src={event.backgroundImagePageUrl}
                      alt="background"
                      style={{ width: 40, height: 40, objectFit: "contain" }}
                    />
                  ) : (
                    ""
                  )}
                </TableCell>
                <TableCell align="center">
                  {event.backgroundPageHomeUrl ? (
                    <img
                      src={event.backgroundPageHomeUrl}
                      alt="background"
                      style={{ width: 40, height: 40, objectFit: "contain" }}
                    />
                  ) : (
                    ""
                  )}
                </TableCell>
                <TableCell align="center">
                  {event.backgroundPageUrl ? (
                    <img
                      src={event.backgroundPageUrl}
                      alt="background"
                      style={{ width: 40, height: 40, objectFit: "contain" }}
                    />
                  ) : (
                    ""
                  )}
                </TableCell>
                <TableCell align="center">{event.textImage}</TableCell>
                <TableCell align="center">
                  {event.Rm_Bg ? "oui" : "non"}
                </TableCell>
                <TableCell align="center">
                  {event.startDate
                    ? new Date(event.startDate).toLocaleDateString()
                    : ""}
                </TableCell>
                <TableCell align="center">
                  {event.endDate
                    ? new Date(event.endDate).toLocaleDateString()
                    : ""}
                </TableCell>
                <TableCell align="center">
                  {event.Rm_Bg && (
                    <IconButton
                      onClick={() => {
                        setOpenBackgroundId(event.id);
                        setOpenBackground(true);
                      }}
                      color="secondary"
                    >
                      <WallpaperIcon />
                    </IconButton>
                  )}

                  <IconButton
                    color="primary"
                    onClick={() => {
                      setFormData({
                        id: event.id,
                        Nom: event.Nom || "",
                        code: event.code || "",
                        startDate: event.startDate
                          ? event.startDate.slice(0, 10)
                          : "",
                        endDate: event.endDate
                          ? event.endDate.slice(0, 10)
                          : "",
                        logo: event.logo || "",
                        BG_ImageCodeColor: event.BG_ImageCodeColor || "",
                        logoImage: event.logoImage || null,
                        backgroundImageUrl: event.backgroundImageUrl || null,
                        backgroundPageUrl: event.backgroundPageUrl || null,
                        backgroundPageHomeUrl:
                          event.backgroundPageHomeUrl || null,
                        backgroundImagePageUrl:
                          event.backgroundImagePageUrl || null,
                        textImage: event.textImage || "",
                        Rm_Bg: !!event.Rm_Bg,
                        ImageGratuit: event.ImageGratuit || 0,
                        idProduit: event.idProduit || "",
                      });
                      /*  setLogoPreview(
                        event.logoImage
                          ? event.logoImage.startsWith("http")
                            ? event.logoImage
                            : `${api_base}uploads/${event.logoImage}`
                          : ""
                      );
                      setBackgroundPreview(
                        event.backgroundImageUrl
                          ? event.backgroundImageUrl.startsWith("http")
                            ? event.backgroundImageUrl
                            : `${api_base}uploads/${event.backgroundImageUrl}`
                          : ""
                      );*/
                      setPopupForm(true);
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    color="error"
                    onClick={() => {
                      setIdDelete(event.id);
                      setPopupDelete(true);
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={Data?.totalItems || 0}
          page={page}
          onPageChange={(event, newPage) => setPage(newPage)}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
          }}
          rowsPerPageOptions={[5, 10, 15]}
        />
      </Paper>
      <Dialog
        open={popupForm}
        onClose={() => {
          DataInisial();
          setPopupForm(false);
        }}
      >
        <form onSubmit={handleFormSubmit}>
          <DialogTitle>
            {formData.id ? "Modifier" : "Ajouter"} Event
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2} mb={2}>
              <Grid item xs={12}>
                <FormControl fullWidth sx={{}}>
                  <InputLabel id="produit">produit</InputLabel>
                  <Select
                    labelId="produit"
                    id="remove-bg"
                    required
                    value={formData.idProduit}
                    onChange={(e) =>
                      setFormData({ ...formData, idProduit: e.target.value })
                    }
                    label="produit"
                  >
                    {Produits.map((produit) => (
                      <MenuItem key={produit.id} value={produit.id}>
                        {produit.NomProduit}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <TextField
                  margin="dense"
                  label="Nom"
                  required
                  fullWidth
                  value={formData.Nom}
                  onChange={(e) =>
                    setFormData({ ...formData, Nom: e.target.value })
                  }
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  margin="dense"
                  label="Code"
                  required
                  fullWidth
                  value={formData.code}
                  onChange={(e) =>
                    setFormData({ ...formData, code: e.target.value })
                  }
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  margin="dense"
                  label="Date début"
                  required
                  type="date"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={formData.startDate}
                  onChange={(e) =>
                    setFormData({ ...formData, startDate: e.target.value })
                  }
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  margin="dense"
                  label="Date fin"
                  type="date"
                  required
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={formData.endDate}
                  onChange={(e) =>
                    setFormData({ ...formData, endDate: e.target.value })
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h5">Option : </Typography>
              </Grid>

              <Grid item xs={12}>
                <Typography> text sous photo</Typography>
                <TextField
                  margin="dense"
                  label="text image"
                  type="text"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={formData.textImage}
                  onChange={(e) =>
                    setFormData({ ...formData, textImage: e.target.value })
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <Typography> Supprime arrière plan photo</Typography>
                <FormControl fullWidth sx={{ marginTop: 1 }}>
                  <InputLabel id="remove-bg-label">
                    Supprime arrière plan
                  </InputLabel>
                  <Select
                    labelId="remove-bg-label"
                    id="remove-bg"
                    value={formData.Rm_Bg ? "true" : "false"}
                    onChange={handleRmBgChange}
                    label="Supprime arrière plan"
                  >
                    <MenuItem value="false">Non</MenuItem>
                    <MenuItem value="true">Oui</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Typography> arrière plan papier color</Typography>
                <Box
                  display="flex"
                  sx={{ width: "100%" }}
                  alignItems="center"
                  gap={2}
                >
                  <TextField
                    margin="dense"
                    label="arrière plan couleur"
                    type="color"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    value={formData.BG_ImageCodeColor || "#ffffff"}
                    onChange={handleColorChange}
                    //  sx={{ width: "80px" }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Typography> Logo Evenement</Typography>
                <Box alignItems="center" gap={2}>
                  {!formData.logoImage ? (
                    <Button
                      variant="outlined"
                      component="label"
                      size="small"
                      fullWidth
                    >
                      Ajouter Logo
                      <input
                        type="file"
                        accept="image/*"
                        hidden
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            setFormData({ ...formData, logoImage: file });
                          }
                        }}
                      />
                    </Button>
                  ) : (
                    <Box position="relative" display="inline-block">
                      <img
                        src={
                          formData.logoImage instanceof File
                            ? URL.createObjectURL(formData.logoImage)
                            : formData.logoImage
                        }
                        alt="logo preview"
                        style={{
                          width: 100,
                          height: 100,
                          objectFit: "contain",
                          borderRadius: 6,
                          border: "1px solid #ddd",
                        }}
                      />

                      {/* Icon inside image */}
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => {
                          setFormData({ ...formData, logoImage: null });
                        }}
                        sx={{
                          position: "absolute",
                          top: -8,
                          right: -8,
                          background: "#fff",
                          boxShadow: 2,
                          "&:hover": { background: "#ffe5e5" },
                          width: 24,
                          height: 24,
                        }}
                      >
                        <ClearIcon sx={{ fontSize: 18 }} />
                      </IconButton>
                    </Box>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Typography>arrière plan papier Image </Typography>
                <Box display="flex" alignItems="center" gap={2}>
                  {!formData.backgroundImageUrl ? (
                    <Button
                      variant="outlined"
                      component="label"
                      size="small"
                      fullWidth
                    >
                      Ajouter arrière plan papier Image
                      <input
                        type="file"
                        accept="image/*"
                        hidden
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            setFormData({
                              ...formData,
                              backgroundImageUrl: file,
                            });
                          }
                        }}
                      />
                    </Button>
                  ) : (
                    <Box position="relative" display="inline-block">
                      <img
                        src={
                          formData.backgroundImageUrl instanceof File
                            ? URL.createObjectURL(formData.backgroundImageUrl)
                            : formData.backgroundImageUrl
                        }
                        alt="background preview"
                        style={{
                          width: 100,
                          height: 100,
                          objectFit: "contain",
                          borderRadius: 6,
                          border: "1px solid #ddd",
                        }}
                      />

                      {/* Icon inside image */}
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => {
                          setFormData({
                            ...formData,
                            backgroundImageUrl: null,
                          });
                        }}
                        sx={{
                          position: "absolute",
                          top: -8,
                          right: -8,
                          background: "#fff",
                          boxShadow: 2,
                          "&:hover": { background: "#ffe5e5" },
                          width: 24,
                          height: 24,
                        }}
                      >
                        <ClearIcon sx={{ fontSize: 18 }} />
                      </IconButton>
                    </Box>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Typography>arrière plan papier Image affiche pour le client</Typography>
                <Box display="flex" alignItems="center" gap={2}>
                  {!formData.backgroundImagePageUrl ? (
                    <Button
                      variant="outlined"
                      component="label"
                      size="small"
                      fullWidth
                    >
                      arrière plan papier Image affiche pour le client
                      <input
                        type="file"
                        accept="image/*"
                        hidden
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            setFormData({
                              ...formData,
                              backgroundImagePageUrl: file,
                            });
                          }
                        }}
                      />
                    </Button>
                  ) : (
                    <Box position="relative" display="inline-block">
                      <img
                        src={
                          formData.backgroundImagePageUrl instanceof File
                            ? URL.createObjectURL(
                                formData.backgroundImagePageUrl
                              )
                            : formData.backgroundImagePageUrl
                        }
                        alt="background preview"
                        style={{
                          width: 100,
                          height: 100,
                          objectFit: "contain",
                          borderRadius: 6,
                          border: "1px solid #ddd",
                        }}
                      />

                      {/* Icon inside image */}
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => {
                          setFormData({
                            ...formData,
                            backgroundImagePageUrl: null,
                          });
                        }}
                        sx={{
                          position: "absolute",
                          top: -8,
                          right: -8,
                          background: "#fff",
                          boxShadow: 2,
                          "&:hover": { background: "#ffe5e5" },
                          width: 24,
                          height: 24,
                        }}
                      >
                        <ClearIcon sx={{ fontSize: 18 }} />
                      </IconButton>
                    </Box>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Typography>arrière plan Home event</Typography>
                <Box display="flex" alignItems="center" gap={2}>
                  {!formData.backgroundPageHomeUrl ? (
                    <Button
                      variant="outlined"
                      component="label"
                      size="small"
                      fullWidth
                    >
                      Ajouter arrière plan page home event
                      <input
                        type="file"
                        accept="image/*"
                        hidden
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            setFormData({
                              ...formData,
                              backgroundPageHomeUrl: file,
                            });
                          }
                        }}
                      />
                    </Button>
                  ) : (
                    <Box position="relative" display="inline-block">
                      <img
                        src={
                          formData.backgroundPageHomeUrl instanceof File
                            ? URL.createObjectURL(
                                formData.backgroundPageHomeUrl
                              )
                            : formData.backgroundPageHomeUrl
                        }
                        alt="background preview"
                        style={{
                          width: 100,
                          height: 100,
                          objectFit: "contain",
                          borderRadius: 6,
                          border: "1px solid #ddd",
                        }}
                      />
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => {
                          setFormData({
                            ...formData,
                            backgroundPageHomeUrl: null,
                          });
                        }}
                        sx={{
                          position: "absolute",
                          top: -8,
                          right: -8,
                          background: "#fff",
                          boxShadow: 2,
                          "&:hover": { background: "#ffe5e5" },
                          width: 24,
                          height: 24,
                        }}
                      >
                        <ClearIcon sx={{ fontSize: 18 }} />
                      </IconButton>
                    </Box>
                  )}
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Typography>arrière plan page event</Typography>
                <Box display="flex" alignItems="center" gap={2}>
                  {!formData.backgroundPageUrl ? (
                    <Button
                      variant="outlined"
                      component="label"
                      size="small"
                      fullWidth
                    >
                      Ajouter arrière plan page event
                      <input
                        type="file"
                        accept="image/*"
                        hidden
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            setFormData({
                              ...formData,
                              backgroundPageUrl: file,
                            });
                          }
                        }}
                      />
                    </Button>
                  ) : (
                    <Box position="relative" display="inline-block">
                      <img
                        src={
                          formData.backgroundPageUrl instanceof File
                            ? URL.createObjectURL(formData.backgroundPageUrl)
                            : formData.backgroundPageUrl
                        }
                        alt="background preview"
                        style={{
                          width: 100,
                          height: 100,
                          objectFit: "contain",
                          borderRadius: 6,
                          border: "1px solid #ddd",
                        }}
                      />
                      <IconButton
                        size="small"
                        color="error"
                        onClick={() => {
                          setFormData({ ...formData, backgroundPageUrl: null });
                        }}
                        sx={{
                          position: "absolute",
                          top: -8,
                          right: -8,
                          background: "#fff",
                          boxShadow: 2,
                          "&:hover": { background: "#ffe5e5" },
                          width: 24,
                          height: 24,
                        }}
                      >
                        <ClearIcon sx={{ fontSize: 18 }} />
                      </IconButton>
                    </Box>
                  )}
                </Box>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                DataInisial();
                setPopupForm(false);
              }}
            >
              Annuler
            </Button>
            <Button type="submit" color="primary">
              {formData.id ? "Modifier" : "Ajouter"}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      <ConfirmDeletePopup
        open={popupDelete}
        onClose={() => setPopupDelete(false)}
        confirm={handleDelete}
      />
      <PopupGestionBackground
        open={openBackground}
        onClose={() => {
          setOpenBackgroundId(null);
          setOpenBackground(false);
        }}
        eventId={openBackgroundId}
      />
      <BackLoadingSimple open={loading} />
    </Box>
  );
}
